const type = {
  FROM: 1,
  TO: 2
};

export default type;
